export default {
  main: '#f0ede5',
  secondary: '#000000',
  contrastingColor: '#000000',
  priceColor: '#000000',
  entryBackground: '#f0ede5',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#ffffff',
};
